import {
  ABSENCES_GET,
  ABSENCE_ADD,
  ABSENCE_EDIT,
  ABSENCE_GET,
  ABSENCE_DELETE,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
    yearFilter: '',
    semFilter: '',
  },
  items: [], //classyears
  gurus: [],
  jenjangs: [],
  kelass: [],
  years: [],
  sems: [],
  studentAbsences: [],
};

const absencesGet = (state, payload) => {
  const rawAbsences = payload.absences;
  const total = rawAbsences.total;
  const items = rawAbsences.items;
  const search = rawAbsences.search;
  const jenjangs = rawAbsences.jenjangs;
  const kelass = rawAbsences.kelass;
  const years = rawAbsences.years;
  const sems = rawAbsences.sems;
  return {
    ...state,
    total,
    items,
    search,
    jenjangs,
    kelass,
    years,
    sems,
  };
};

const absenceAdd = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) + 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.absence.id + ''),
      payload.absence,
    ],
    search: { ...state.search },
  };
};

const absenceEdit = (state, payload) => {
  let stAbsences = payload?.absence?.studentAbsences;
  let id = payload?.absence?.classyearId;

  return {
    ...state,
    studentAbsences: {
      ...state.studentAbsences,
      [id]: stAbsences,
    },
  };
};

const absenceGet = (state, payload) => {
  let rawAbsence = payload.absence;
  let absence = rawAbsence.absence;
  let gurus = rawAbsence.gurus;
  let jenjangs = rawAbsence.jenjangs;
  let kelass = rawAbsence.kelass;
  let years = rawAbsence.years;
  let sems = rawAbsence.sems;
  let stAbsences = rawAbsence.studentAbsences;
  let studentAbsences = { ...state.studentAbsences };
  let newItems = [...state.items];

  if (absence) {
    newItems = [
      ...state.items.filter((i) => i.id + '' !== absence.id + ''),
      absence,
    ];
  }

  if(stAbsences) {
    studentAbsences = {
      ...state.studentAbsences,
      [stAbsences.id]: stAbsences.studentAbsences,
    };
  }

  let newState = {
    ...state,
    items: newItems,
    gurus,
    jenjangs,
    kelass,
    years,
    sems,
    studentAbsences,
  };
  return newState;
};

const absenceDelete = (state, payload) => {
  let studentAbsences = { ...state.studentAbsences };
  delete studentAbsences[payload.absence.id];
  return {
    ...state,
    studentAbsences,
  };
};

export default createReducer(initialState, {
  [ABSENCES_GET]: absencesGet,
  [ABSENCE_ADD]: absenceAdd,
  [ABSENCE_EDIT]: absenceEdit,
  [ABSENCE_GET]: absenceGet,
  [ABSENCE_DELETE]: absenceDelete,
});
